import Affix from './affix';
import Alert from './alert';
import Anchor from './anchor';
import AutoComplete from './auto-complete';
import Avatar from './avatar';
import BackTop from './back-top';
import Badge from './badge';
import Breadcrumb from './breadcrumb';
import Button from './button';
import Calendar from './calendar';
import Cascader from './cascader';
import Checkbox from './checkbox';
import Collapse from './collapse';
import DatePicker from './date-picker';
import Divider from './divider';
import Dropdown from './dropdown';
import Drawer from './drawer';
import Form from './form';
import Col from './grid/col';
import Row from './grid/row';
import Icon from './icon';
import Input from './input';
import InputNumber from './input-number';
import Layout from './layout';
import Menu from './menu';
import Message from './message';
import Modal from './modal';
import Pagination from './pagination';
import Popconfirm from './popconfirm';
import Popover from './popover';
import Progress from './progress';
import Radio from './radio';
import Select from './select';
import Slider from './slider';
import Spin from './spin';
import Steps from './steps';
import Switch from './switch';
import Table from './table';
import Tabs from './tabs';
import Tag from './tag';
import TimePicker from './time-picker';
import Timeline from './timeline';
import Tooltip from './tooltip';
import Tree from './tree';
import Transfer from './transfer';
import TreeSelect from './tree-select';
import Upload from './upload';
import Version from './version';
import PrevPage from './prevPage';
import Empty from './empty';
import ConfigProvider from './config-provider';
import Color from './color';
import Typography from './typography';

export {
  Affix,
  Alert,
  AutoComplete,
  Avatar,
  Anchor,
  BackTop,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Cascader,
  Checkbox,
  Collapse,
  DatePicker,
  Divider,
  Dropdown,
  Drawer,
  Form,
  Row,
  Col,
  Icon,
  Input,
  InputNumber,
  Layout,
  Menu,
  Message,
  Modal,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Select,
  Slider,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  TimePicker,
  Timeline,
  Tooltip,
  Tree,
  Transfer,
  TreeSelect,
  Upload,
  Version,
  PrevPage,
  Empty,
  ConfigProvider,
  Color,
  Typography
};


